export default "__VITE_ASSET__DZrhmubj__"